import { render } from "./BookingAddress.vue?vue&type=template&id=5567c821"
import script from "./BookingAddress.vue?vue&type=script&lang=js"
export * from "./BookingAddress.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Furbetta\\WebAppPrenotazionePrimaVisita\\booking-prima-visita-v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__